import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import CategoryMasterTab from "./CategoryMasterTab";
import VendorBillsTab from "./VendorBillsTab";
import PaymentListsTab from "./PaymentListsTab";
import CompletedPaymentsTab from "./CompletedPaymentsTab";
import PostFactoEntriesTab from "./PostFactoEntriesTab";
import ApprovalQueueTab from "./ApprovalQueueTab";
import ExecutionQueueTab from "./ExecutionQueueTab";
import ExpenseTrackerTab from "./ExpenseTrackerTab";
import DeletedEntriesTab from "./DeletedEntriesTab";
import ImprestTab from "./imprest/ImprestTab";
import { NoAccess } from "../equipment/shared/NoAccess";
import { ErrorBoundary } from "@/components/shared/ErrorBoundary";

const ALL_ROLES = ["Director", "Manager", "Accounts", "Back Office"];
const CashEntriesTab = () => <PostFactoEntriesTab mode="Cash" />;
const UpiEntriesTab = () => <PostFactoEntriesTab mode="UPI" />;

const TABS = [
  { key: "bills", label: "Vendor Bills / Payables", Component: VendorBillsTab, roles: ALL_ROLES },
  { key: "payment-lists", label: "Payment Lists (RTGS/NEFT)", Component: PaymentListsTab, roles: ALL_ROLES },
  { key: "completed-payments", label: "Completed Payments", Component: CompletedPaymentsTab, roles: ALL_ROLES },
  { key: "cash", label: "Cash Entries", Component: CashEntriesTab, roles: ALL_ROLES },
  { key: "upi", label: "UPI Entries", Component: UpiEntriesTab, roles: ALL_ROLES },
  { key: "imprest", label: "Imprest", Component: ImprestTab, roles: ALL_ROLES },
  { key: "expenses", label: "Expense Tracker", Component: ExpenseTrackerTab, roles: ALL_ROLES },
  { key: "approval-queue", label: "Approval Queue", Component: ApprovalQueueTab, roles: ALL_ROLES },
  { key: "execution-queue", label: "Execution Queue", Component: ExecutionQueueTab, roles: ["Accounts"] },
  { key: "deleted", label: "Deleted Entries", Component: DeletedEntriesTab, roles: ["Director", "Manager", "Accounts", "Back Office"] },
  { key: "categories", label: "Payment Category", Component: CategoryMasterTab, roles: ALL_ROLES },
];

export default function PaymentDeskPage() {
  const { user } = useAuth();
  const visible = TABS.filter((t) => t.roles.includes(user?.role));
  const [active, setActive] = useState(visible[0]?.key);

  if (visible.length === 0) return <NoAccess />;

  return (
    <div className="space-y-6" data-testid="payment-desk-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
          Payment Desk
        </h1>
        <p className="text-sm text-slate-500">Vendor bills, RTGS/NEFT approvals and vendor/category masters.</p>
      </div>
      <Tabs value={active} onValueChange={setActive}>
        <TabsList className="flex-wrap h-auto">
          {visible.map((t) => (
            <TabsTrigger key={t.key} value={t.key} data-testid={`payment-desk-tab-${t.key}`}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {visible.map((t) => (
          <TabsContent key={t.key} value={t.key} className="pt-4">
            <ErrorBoundary key={t.key} testId="payment-desk-error-boundary">
              <t.Component />
            </ErrorBoundary>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
